// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"136":"faa59f2f","295":"ca10b067","423":"9e4c08af"}[chunkId] + ".css";
};